import React, { useEffect, useState } from 'react';
import AuthorComponent from '../../../components/authorComponent/AuthorComponent';
import Banner1 from '../../../components/banners/banner1/Banner1';
import Banner2 from '../../../components/banners/banner2/Banner2';
import Banner3 from '../../../components/banners/banner3/Banner3';
import Banner4 from '../../../components/banners/banner4/Banner4';
import Slider from '../../../components/Slider/Slider';
import BookComponent from '../../../components/bookComponent/BookComponent';
import CategoryComponent from '../../../components/categoryComponent/CategoryComponent';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../Main';
import DownloadBanner from '../../../components/banners/banner5/DownloadBanner';

function Home() {
  const { isAuth } = React.useContext(AuthContext);
  const { windowDimensions, recentBook, mostViewedBook, newestAdded, newestPublished, favoritesBook, authors, categories } =
    useForm();
  const { t, i18n } = useTranslation();

  const booksList = (books, review, read) => {
    return books.map((book, index) => (
      <div key={'book-' + index}>
        <BookComponent data={book} reviewBoolean={review} readBoolean={read} widthWindow={windowDimensions.width} />
      </div>
    ));
  };

  const authorsList = () => {
    return authors.map((author, index) => (
      <div key={'author-' + index}>
        <AuthorComponent data={author} widthWindow={windowDimensions.width} />
      </div>
    ));
  };

  const Categories = () => {
    return categories.map((category, index) => (
      <div key={'category-' + index}>
        <CategoryComponent data={category} widthWindow={windowDimensions.width} />
      </div>
    ));
  };

  const responsiveBookSlider = [
    { maxWidth: 1800, slidesToShow: 5.5 },
    { maxWidth: 1600, slidesToShow: 4.8 },
    { maxWidth: 1400, slidesToShow: 4.2 },
    { maxWidth: 1200, slidesToShow: 3.6 },
    { maxWidth: 992, slidesToShow: 3.8 },
    { maxWidth: 800, slidesToShow: 3.5 },
    { maxWidth: 768, slidesToShow: 4.5 },
    { maxWidth: 600, slidesToShow: 3.8 },
    { maxWidth: 500, slidesToShow: 3.2 },
    { maxWidth: 450, slidesToShow: 2.9 },
    { maxWidth: 400, slidesToShow: 2.6 },
    { maxWidth: 360, slidesToShow: 2.2 },
    { maxWidth: 300, slidesToShow: 1.8 },
  ];

  return (
    <div>
      <Banner1 />
      {isAuth && (
        <>
          {' '}
          <Slider
            title={t('slider.title.RECENT_READ')}
            more="/books?queryType=RECENT_READ"
            slidesToShow="5.8"
            responsive={responsiveBookSlider}
            items={() => booksList(recentBook, true, true)}
          />
          <Slider
            title={t('slider.title.FAVORITES')}
            more="/books?queryType=FAVORITES"
            slidesToShow="5.8"
            responsive={responsiveBookSlider}
            items={() => booksList(favoritesBook, false, false)}
          />
        </>
      )}

      <Slider
        title={t('slider.title.NEWEST_PUBLISHED')}
        more="/books?queryType=NEWEST_PUBLISHED"
        slidesToShow="5.8"
        responsive={responsiveBookSlider}
        items={() => booksList(newestPublished, false, false)}
      />
      <Banner2 />
      <Slider
        title={t('slider.title.categories')}
        // more="aaaa"
        slidesToShow="5.8"
        responsive={[{ maxWidth: 1600, slidesToShow: 3 }]}
        items={Categories}
        rows={2}
      />
      <Slider
        title={t('slider.title.MOST_VIEWED')}
        more="/books?queryType=MOST_VIEWED"
        slidesToShow="5.8"
        responsive={responsiveBookSlider}
        items={() => booksList(mostViewedBook, true, false)}
      />
      <Slider
        title={t('slider.title.NEWEST_ADDED')}
        more="/books?queryType=NEWEST_PUBLISHED"
        slidesToShow="5.8"
        responsive={responsiveBookSlider}
        items={() => booksList(newestAdded, false, false)}
      />
      {/* <Banner3 />

      <Banner4 /> */}
      {windowDimensions.width > 992 ? (
        <Slider
          title={t('slider.title.authors')}
          slidesToShow="5"
          items={authorsList}
          responsive={[
            { maxWidth: 1800, slidesToShow: 4.5 },
            { maxWidth: 1600, slidesToShow: 4 },
            { maxWidth: 1400, slidesToShow: 3.5 },
            { maxWidth: 1200, slidesToShow: 3.6 },
            { maxWidth: 1000, slidesToShow: 3.7 },
            { maxWidth: 992, slidesToShow: 3.5 },
          ]}
        />
      ) : (
        <Slider
          title={t('slider.title.authors')}
          slidesToShow="3.2"
          responsive={[
            { maxWidth: 992, slidesToShow: 3.2 },
            { maxWidth: 768, slidesToShow: 3.8 },
            { maxWidth: 700, slidesToShow: 3.5 },
            { maxWidth: 600, slidesToShow: 3.1 },
            { maxWidth: 550, slidesToShow: 2.8 },
            { maxWidth: 450, slidesToShow: 2.4 },
            { maxWidth: 400, slidesToShow: 2.2 },
            { maxWidth: 360, slidesToShow: 1.7 },
          ]}
          items={authorsList}
          rows={2}
        />
      )}
      <DownloadBanner />
    </div>
  );
}

export default Home;

